import { useState } from 'react';
import { CodeConfirmationForm } from '@/ui/components/CodeConfirmationForm';
import { emailVerification } from '@/assets/images/emojis';
import styles from './EmailConfirmationPage.module.scss';
import { useUser } from '@/features/user';
import { useEmailCode } from '../../hooks/useEmailCode';
import { routes } from '@/routes';
import { Link, useNavigate } from 'react-router-dom';

export function EmailConfirmationPage() {
  const { user } = useUser();
  const navigate = useNavigate();
  const { confirmCode, resendCode, resendDelay, isLoading } = useEmailCode();
  const [emailCode, setEmailCode] = useState('');

  const handleValidate = async (code: string) => {
    if (await confirmCode(code)) {
      navigate(routes.wizard.base);
    }
  };

  const handleRequestEmailValidation = async () => {
    if (await resendCode()) {
      setEmailCode('');
    }
  };

  const handleCodeChange = (value: string) => {
    setEmailCode(value);
    if (value.length === 6) {
      void handleValidate(value);
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <img
          src={emailVerification}
          alt="Email verification emoji"
          className={styles.emoji}
        />
        <div className={styles.titleSection}>
          <h1 className={styles.title}>
            Verifică-ți adresa
            <br />
            de email
          </h1>
          <div className={styles.description}>
            <p>Am trimis codul de confirmare către</p>
            <p>
              {user?.email} (
              <Link
                to={routes.email.base}
                className={styles.changeEmailButton}
              >
                Schimbă email
              </Link>
              )
            </p>
          </div>
        </div>
      </div>

      <CodeConfirmationForm
        value={emailCode}
        onChange={handleCodeChange}
        onResendCode={handleRequestEmailValidation}
        isLoading={isLoading}
        resendDelay={resendDelay}
        autoFocus
      />
    </div>
  );
}

export default EmailConfirmationPage;
